let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("g9oxW")).then(() => parcelRequire('EgBsF'));